/**
 * @deprecated import colors from @addi/foundation/dist/web/colors instead
 */
const Gray = {
    normal: '#d8d8d8',
    obscure: '#666666',
    dark: '#a4a4a4',
    light: '#eeeeee',
    highLight: '#F5F9FC',
    background: '#161616',
    backgroundDark: '#ececec'
};
export default Gray;
//# sourceMappingURL=gray.js.map